module.exports = __webpack_public_path__ + "img/chevronLeft.1d42cb3b.svg";